// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".job-item.--highlighted[data-v-45cafdf8]{background-color:var(--bg-light)}.job-item__repeat-button[data-v-45cafdf8]{display:inline-flex;padding:4px;border-radius:20px;min-height:auto!important}.job-item__repeat-button>i[data-v-45cafdf8]{font-size:inherit}.job-item.active[data-v-45cafdf8]{font-weight:550;letter-spacing:.015rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
